// extracted by mini-css-extract-plugin
export default {"wrap":"font-size__wrap___C","number":"font-size__number__Fi","unit":"font-size__unit__D2"};